/**
 * @ngdoc service
 * @name checkins.factory:viewBookings
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .factory('viewBookings', [
        '$state',
        viewBookings
    ]);

function viewBookings($state) {
    return {
        key: 'view-bookings',
        title: 'Bookings',
        level: 'row',
        action: function ({row}) {
            if(row.settings_enable_seatplan && row.seatplan_id) {
                return $state.go('app.guestlists.rsvps.seats', {gid: row.id});
            } else {
                return $state.go('app.guestlists.rsvps.index', {gid: row.id});
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/view-bookings.js